export default "__VITE_ASSET__BctfR4Ah__"